import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'kabas-legals-page-privacy',
  templateUrl: './legals-page-privacy.component.html',
})
export class LegalsPagePrivacyComponent {}
